<section *ngIf="!!postContent" class="pb-[12px]">
  <div *ngIf="!hideTitle" class="pt-[24px] pb-[16px] text-center">
    <h5 class="post-content__title px-[16px]">{{postContent.title}}</h5>
    <p class="post-content__created-date">{{postContent.createdDate | date:'longDate'}}</p>
  </div>
  <article class="overflow-hidden">
    <app-post-content-detail-section
      [content]="postContent.content"
      [fullscreen]="fullscreen"
    ></app-post-content-detail-section>
  </article>
  @if (!hideRelevantPosts) {
  <div
    class="post-content-detail__relevant-items overflow-x-auto px-[16px] pt-[8px] pb-[32px] mb-[8px] flex flex-nowrap gap-x-[16px] scrollbar-hide md:scrollbar-default"
  >
    @for(p of relevantPosts; track $index) {
    <app-post-card-component [post]="p" class="w-[160px] h-[216px] shrink-0"></app-post-card-component>
    }
  </div>
  } @if (!hideActions) {
  <div
    class="post-content__action-bar w-[240px] h-[48px] bg-white/80 border-[2px] border-white rounded-full mx-auto flex justify-between items-center sticky bottom-[10px] z-50 backdrop-blur-[16px]"
  >
    <span (click)="handleLikeClicked('like')" class="w-[80px] h-[48px] flex items-center justify-center">
      <svg
        class="w-6 h-6"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        attr.fill="{{like ? 'currentColor' : 'none'}}"
        viewBox="0 0 24 24"
      >
        <path
          *ngIf="!like"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M7 11c.889-.086 1.416-.543 2.156-1.057a22.323 22.323 0 0 0 3.958-5.084 1.6 1.6 0 0 1 .582-.628 1.549 1.549 0 0 1 1.466-.087c.205.095.388.233.537.406a1.64 1.64 0 0 1 .384 1.279l-1.388 4.114M7 11H4v6.5A1.5 1.5 0 0 0 5.5 19v0A1.5 1.5 0 0 0 7 17.5V11Zm6.5-1h4.915c.286 0 .372.014.626.15.254.135.472.332.637.572a1.874 1.874 0 0 1 .215 1.673l-2.098 6.4C17.538 19.52 17.368 20 16.12 20c-2.303 0-4.79-.943-6.67-1.475"
        />
        <path
          *ngIf="like"
          fill-rule="evenodd"
          d="M15.03 9.684h3.965c.322 0 .64.08.925.232.286.153.532.374.717.645a2.109 2.109 0 0 1 .242 1.883l-2.36 7.201c-.288.814-.48 1.355-1.884 1.355-2.072 0-4.276-.677-6.157-1.256-.472-.145-.924-.284-1.348-.404h-.115V9.478a25.485 25.485 0 0 0 4.238-5.514 1.8 1.8 0 0 1 .901-.83 1.74 1.74 0 0 1 1.21-.048c.396.13.736.397.96.757.225.36.32.788.269 1.211l-1.562 4.63ZM4.177 10H7v8a2 2 0 1 1-4 0v-6.823C3 10.527 3.527 10 4.176 10Z"
          clip-rule="evenodd"
        />
      </svg>
    </span>
    <span (click)="sharePost()" class="w-[80px] h-[48px] flex items-center justify-center md:hidden">
      <svg
        class="w-6 h-6"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-width="2"
          d="M7.926 10.898 15 7.727m-7.074 5.39L15 16.29M8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm12 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0-11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
        />
      </svg>
    </span>
    <span
      #postUrlButtonElementRef
      (click)="handleCopyPostUrlClicked()"
      class="w-[80px] h-[48px] hidden md:flex md:items-center md:justify-center"
    >
      <input
        #postUrlInputElementRef
        type="hidden"
        id="post-url-input"
        [value]="copyLink ? `${copyLink}` : `${config.baseUrl}/post/${postContent.slug}`"
      />
      <svg
        id="default-icon"
        class="w-6 h-6"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M13.213 9.787a3.391 3.391 0 0 0-4.795 0l-3.425 3.426a3.39 3.39 0 0 0 4.795 4.794l.321-.304m-.321-4.49a3.39 3.39 0 0 0 4.795 0l3.424-3.426a3.39 3.39 0 0 0-4.794-4.795l-1.028.961"
        />
      </svg>
      <svg
        id="success-icon"
        class="w-6 h-6 hidden"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 16 12"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M1 5.917 5.724 10.5 15 1.5"
        />
      </svg>
      <span
        #copyPostUrlTooltipElementRef
        id="copy-post-url-tooltip"
        role="tooltip"
        class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-xs opacity-0 tooltip dark:bg-gray-700"
      >
        <span #copyPostUrlDefaultTooltipMessageElementRef id="default-tooltip-message">Copy to clipboard</span>
        <span #copyPostUrlSuccessTooltipMessageElementRef id="success-tooltip-message" class="hidden">Copied!</span>
        <span class="tooltip-arrow" data-popper-arrow></span>
      </span>
    </span>
    <span (click)="handleLikeClicked('unlike')" class="w-[80px] h-[48px] flex items-center justify-center">
      <svg
        class="w-6 h-6"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        attr.fill="{{unlike ? 'currentColor' : 'none'}}"
        viewBox="0 0 24 24"
      >
        <path
          *ngIf="!unlike"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 13c-.889.086-1.416.543-2.156 1.057a22.322 22.322 0 0 0-3.958 5.084 1.6 1.6 0 0 1-.582.628 1.549 1.549 0 0 1-1.466.087 1.587 1.587 0 0 1-.537-.406 1.666 1.666 0 0 1-.384-1.279l1.389-4.114M17 13h3V6.5A1.5 1.5 0 0 0 18.5 5v0A1.5 1.5 0 0 0 17 6.5V13Zm-6.5 1H5.585c-.286 0-.372-.014-.626-.15a1.797 1.797 0 0 1-.637-.572 1.873 1.873 0 0 1-.215-1.673l2.098-6.4C6.462 4.48 6.632 4 7.88 4c2.302 0 4.79.943 6.67 1.475"
        />
        <path
          *ngIf="unlike"
          fill-rule="evenodd"
          d="M8.97 14.316H5.004c-.322 0-.64-.08-.925-.232a2.022 2.022 0 0 1-.717-.645 2.108 2.108 0 0 1-.242-1.883l2.36-7.201C5.769 3.54 5.96 3 7.365 3c2.072 0 4.276.678 6.156 1.256.473.145.925.284 1.35.404h.114v9.862a25.485 25.485 0 0 0-4.238 5.514c-.197.376-.516.67-.901.83a1.74 1.74 0 0 1-1.21.048 1.79 1.79 0 0 1-.96-.757 1.867 1.867 0 0 1-.269-1.211l1.562-4.63ZM19.822 14H17V6a2 2 0 1 1 4 0v6.823c0 .65-.527 1.177-1.177 1.177Z"
          clip-rule="evenodd"
        />
      </svg>
    </span>
  </div>
  }
</section>
